module.exports = __webpack_public_path__ + "img/tonga.b2805352.svg";